import { api as dataEnteringApi } from "../api";
import { DataResponse } from "./types";
import { AppDispatch } from "../../../shared/redux/types";

interface FetchDataParams {
    dispatch: AppDispatch;
    accountId: number | null;
    documentId: number | null;
}

export const dataApi = dataEnteringApi.injectEndpoints({
    endpoints: (build) => ({
        getData: build.query<DataResponse, { cacheKey: string }>({
            query: () => ({
                url: `api/v1/data_entering/data`,
            }),
            serializeQueryArgs: ({ queryArgs, endpointName }) =>
                `${endpointName}-${queryArgs.cacheKey}`,
        }),
    }),
});

export const { useGetDataQuery } = dataApi;

export async function fetchData({ dispatch, accountId, documentId }: FetchDataParams) {
    const cacheKey = `${accountId}-${documentId}`;
    const dataPromise = dispatch(dataApi.endpoints.getData.initiate({ cacheKey }));
    try {
        return await dataPromise;
    } finally {
        dataPromise.unsubscribe();
    }
}
